module.exports = __webpack_public_path__ + "static/media/analysis.de25be23.svg";